import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
// import * as serviceWorker from './serviceWorker';
import { DataProvider } from './Context/DataContext'; // Import the context provider
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import WebLoader from './components/elements/Loader/index.jsx';

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_BASEURL,
  cache: new InMemoryCache(),
  
});

const App = lazy(() => import('./App.js'))
const rootElement = document.getElementById('root');


const RootComponent = () => {


  return (

    <ApolloProvider client={client}>
      <Router>
        <Suspense fallback={<WebLoader/>}>
          <DataProvider>
            <App />

          </DataProvider>

        </Suspense>
      </Router>
    </ApolloProvider>

  );
};


createRoot(rootElement).render(<RootComponent />);

// serviceWorker.unregister();
